// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "./resources/layout-and-structure/Box.res.js";
import * as Env from "./core/Env.res.js";
import * as Nav from "./resources/navigation/Nav.res.js";
import * as Auth from "./bundles/Auth/Auth.res.js";
import * as I18n from "./primitives/I18n.res.js";
import * as Icon from "./resources/images-and-icons/Icon.res.js";
import * as Badge from "./resources/feedback-indicators/Badge.res.js";
import * as Group from "./resources/layout-and-structure/Group.res.js";
import * as Hover from "./primitives/Hover.res.js";
import * as React from "react";
import * as Button from "./resources/actions/Button.res.js";
import * as Inline from "./resources/layout-and-structure/Inline.res.js";
import * as AppLayout from "./resources/layout-and-structure/AppLayout.res.js";
import * as TextStyle from "./resources/typography/TextStyle.res.js";
import * as AuthRouter from "./app/Auth/AuthRouter.res.js";
import * as AuthRoutes from "./app/Auth/AuthRoutes.res.js";
import * as BugTracker from "./core/BugTracker.res.js";
import * as HelpCenter from "./core/HelpCenter.res.js";
import * as Navigation from "./primitives/Navigation.res.js";
import * as AdminRouter from "./app/Admin/AdminRouter.res.js";
import * as AdminRoutes from "./app/Admin/AdminRoutes.res.js";
import * as LoadingPage from "./app/Loading/LoadingPage.res.js";
import * as OrderRouter from "./app/Order/OrderRouter.res.js";
import * as OrderRoutes from "./app/Order/OrderRoutes.res.js";
import * as SalesRouter from "./app/Sales/SalesRouter.res.js";
import * as SalesRoutes from "./app/Sales/SalesRoutes.res.js";
import * as Stdlib_List from "@rescript/runtime/lib/es6/Stdlib_List.js";
import * as NotFoundPage from "./app/Error/NotFoundPage.res.js";
import * as CatalogRouter from "./app/Catalog/CatalogRouter.res.js";
import * as CatalogRoutes from "./app/Catalog/CatalogRoutes.res.js";
import * as LoadingRouter from "./app/Loading/LoadingRouter.res.js";
import * as LoadingRoutes from "./app/Loading/LoadingRoutes.res.js";
import * as CustomerRouter from "./app/Customer/CustomerRouter.res.js";
import * as CustomerRoutes from "./app/Customer/CustomerRoutes.res.js";
import * as SessionTracker from "./core/SessionTracker.res.js";
import * as SettingsRouter from "./app/Settings/SettingsRouter.res.js";
import * as SettingsRoutes from "./app/Settings/SettingsRoutes.res.js";
import * as SupplierRouter from "./app/Supplier/SupplierRouter.res.js";
import * as SupplierRoutes from "./app/Supplier/SupplierRoutes.res.js";
import * as AnalyticsRouter from "./app/Analytics/AnalyticsRouter.res.js";
import * as AnalyticsRoutes from "./app/Analytics/AnalyticsRoutes.res.js";
import * as CanarySeparator from "./resources/layout-and-structure/CanarySeparator.res.js";
import * as LegacyDashboard from "./modules/LegacyDashboard.res.js";
import * as MaintenancePage from "./app/Error/MaintenancePage.res.js";
import * as PromotionRouter from "./app/Promotion/PromotionRouter.res.js";
import * as PromotionRoutes from "./app/Promotion/PromotionRoutes.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as AccountingRouter from "./app/Accounting/AccountingRouter.res.js";
import * as AccountingRoutes from "./app/Accounting/AccountingRoutes.res.js";
import * as ComplianceRouter from "./app/Compliance/ComplianceRouter.res.js";
import * as ComplianceRoutes from "./app/Compliance/ComplianceRoutes.res.js";
import * as DesignSystemPage from "./app/DesignSystemPage.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as SettingsShopsPage from "./app/Settings/SettingsShopsPage.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as DesignSystemRoutes from "./app/DesignSystemRoutes.res.js";
import * as StockActivityRouter from "./app/StockActivity/StockActivityRouter.res.js";
import * as StockActivityRoutes from "./app/StockActivity/StockActivityRoutes.res.js";
import * as StockTransferRouter from "./app/StockTransfer/StockTransferRouter.res.js";
import * as StockTransferRoutes from "./app/StockTransfer/StockTransferRoutes.res.js";
import * as CashRegisterReportsRouter from "./app/CashRegisterReports/CashRegisterReportsRouter.res.js";
import * as CashRegisterReportsRoutes from "./app/CashRegisterReports/CashRegisterReportsRoutes.res.js";
let styles = {
  root_closeButton: {
    "opacity-kSiTet": "opacity-x1ks1olk",
    ":not(:hover)_backgroundColor-kmRCyk": "backgroundColor-x1lujfql",
    $$css: "wino-gc:src/App.res.js:67"
  }
};
function App$AlertBar(props) {
  let onRequestClose = props.onRequestClose;
  let textLink = props.textLink;
  let link = props.link;
  let variation = props.variation;
  let match = Hover.use(undefined, undefined, undefined);
  let color = variation === "warning" ? "#C22C0C" : variation === "danger" ? "#D92964" : "#455FB2";
  let textVariation = {
    NAME: "custom",
    VAL: color
  };
  let backgroundColor = variation === "warning" ? "#FFE5CF" : variation === "danger" ? "#FCE7F1" : "#E2EBF7";
  return JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsxs(Group.make, {
      children: [JsxRuntime.jsxs(Group.make, {
        children: [JsxRuntime.jsx(Icon.make, {
          name: variation === "info" ? "status_info" : "status_warning",
          fill: color,
          width: 18,
          height: 18,
          bold: true
        }), JsxRuntime.jsxs(TextStyle.make, {
          children: [JsxRuntime.jsx(TextStyle.make, {
            children: props.title + I18n.t(":") + " ",
            variation: textVariation,
            weight: "strong",
            size: "small"
          }), props.subtitle],
          variation: textVariation,
          size: "small"
        })],
        grid: ["max-content", "1fr"],
        wrap: false,
        stretch: false,
        spaceX: "small"
      }), JsxRuntime.jsxs(Inline.make, {
        children: [link !== undefined && textLink !== undefined ? JsxRuntime.jsx(Navigation.Link.make, {
          children: JsxRuntime.jsx(Box.make, {
            children: JsxRuntime.jsx(TextStyle.make, {
              children: textLink + " ➔",
              variation: textVariation,
              weight: "medium",
              size: "small",
              underlined: match[1],
              wrap: false
            }),
            ref: match[0]
          }),
          to: link,
          onPress: props.onPress
        }) : null, onRequestClose !== undefined ? JsxRuntime.jsx(Button.make, {
          ariaLabel: I18n.t("Close"),
          variant: {
            NAME: "ghost",
            VAL: {
              bordered: false
            }
          },
          tone: variation === "warning" ? "warning" : variation === "danger" ? "danger" : "information",
          size: "small",
          bold: true,
          icon: "cross",
          stylex: Primitive_option.some(styles.root_closeButton),
          onPress: () => onRequestClose()
        }) : null],
        space: "large"
      })],
      grid: ["1fr", "max-content"],
      wrap: false,
      spaceX: "large",
      alignY: "center"
    }),
    spaceX: "normal",
    spaceY: "normal",
    style: {
      backgroundColor: backgroundColor
    }
  });
}
let make = React.memo(App$AlertBar);
let AlertBar = {
  styles: styles,
  make: make
};
function App$NavBar(props) {
  let activeRoute = props.activeRoute;
  let activeBaseRoute = props.activeBaseRoute;
  let userImpersonating = props.userImpersonating;
  let userCanUseImpersonation = props.userCanUseImpersonation;
  let navigate = Navigation.useNavigate();
  let scope = Auth.useScope();
  let role = Auth.useRole();
  let settingsAccessAuthorized = Auth.isAuthorizedAccess(role, SettingsRoutes.baseRoute);
  let testMode = Env.context() !== "production";
  let badge;
  if (!testMode && userCanUseImpersonation) {
    badge = JsxRuntime.jsx(Badge.make, {
      children: I18n.t("Support"),
      variation: "primary"
    });
  } else if (!testMode && userImpersonating) {
    badge = JsxRuntime.jsx(Badge.make, {
      children: "⚠️ " + I18n.t("Impersonation"),
      variation: "important"
    });
  } else if (testMode && userCanUseImpersonation) {
    badge = JsxRuntime.jsx(Badge.make, {
      children: I18n.t("Support") + " — Test mode",
      variation: "primary"
    });
  } else if (testMode && userImpersonating) {
    let stringLiteral = "⚠️ " + I18n.t("Impersonation — Test mode");
    badge = JsxRuntime.jsx(Badge.make, {
      children: stringLiteral,
      variation: "important"
    });
  } else {
    badge = testMode ? JsxRuntime.jsx(Badge.make, {
      children: "Test mode"
    }) : undefined;
  }
  let onRequestLogout = () => {
    if (userImpersonating) {
      return Navigation.closeBrowserTab();
    } else {
      return navigate(undefined, AuthRoutes.logoutRoute);
    }
  };
  let restrictedModeForAnalytics = !Auth.isAuthorizedAccess(role, AnalyticsRoutes.overviewRoute);
  let tmp;
  tmp = scope.TAG === "Organisation" ? JsxRuntime.jsx(Nav.NavLink.make, {
    to: {
      TAG: "Route",
      _0: AnalyticsRoutes.shopsRoute
    },
    label: I18n.t("Performances per shop"),
    active: activeRoute === AnalyticsRoutes.shopsRoute,
    restrictedMode: restrictedModeForAnalytics
  }) : null;
  let tmp$1;
  tmp$1 = scope.TAG === "Organisation" ? JsxRuntime.jsx(Nav.NavLink.make, {
    to: {
      TAG: "Route",
      _0: StockTransferRoutes.baseRoute
    },
    label: I18n.t("Stock transfers"),
    active: activeBaseRoute === StockTransferRoutes.baseRoute,
    restrictedMode: !Auth.isAuthorizedAccess(role, StockTransferRoutes.baseRoute)
  }) : null;
  let tmp$2;
  let exit = 0;
  if (scope.TAG === "Organisation" || scope._0.kind !== "WAREHOUSE") {
    exit = 1;
  } else {
    tmp$2 = null;
  }
  if (exit === 1) {
    tmp$2 = JsxRuntime.jsxs(Nav.NavSection.make, {
      children: [JsxRuntime.jsx(Nav.NavLink.make, {
        to: {
          TAG: "Route",
          _0: SalesRoutes.baseRoute
        },
        label: I18n.t("sales_list_page.title"),
        active: activeBaseRoute === SalesRoutes.baseRoute,
        restrictedMode: !Auth.isAuthorizedAccess(role, SalesRoutes.baseRoute)
      }), JsxRuntime.jsx(Nav.NavLink.make, {
        to: {
          TAG: "Route",
          _0: CashRegisterReportsRoutes.baseRoute
        },
        label: I18n.t("cash_register_reports_list_page.title"),
        active: activeBaseRoute === CashRegisterReportsRoutes.baseRoute,
        betaBadge: true,
        restrictedMode: !Auth.isAuthorizedAccess(role, CashRegisterReportsRoutes.baseRoute)
      }), JsxRuntime.jsx(Nav.NavLink.make, {
        to: {
          TAG: "Route",
          _0: AccountingRoutes.baseRoute
        },
        label: I18n.t("Accounting entries"),
        active: activeBaseRoute === AccountingRoutes.baseRoute,
        restrictedMode: !Auth.isAuthorizedAccess(role, AccountingRoutes.baseRoute)
      }), JsxRuntime.jsx(Nav.NavLink.make, {
        to: {
          TAG: "Route",
          _0: PromotionRoutes.baseRoute
        },
        label: I18n.t("Promotional campaigns"),
        active: activeBaseRoute === PromotionRoutes.baseRoute,
        restrictedMode: !Auth.isAuthorizedAccess(role, PromotionRoutes.baseRoute)
      })],
      title: I18n.t("Sales"),
      active: activeBaseRoute === SalesRoutes.baseRoute || activeBaseRoute === CashRegisterReportsRoutes.baseRoute || activeBaseRoute === AccountingRoutes.baseRoute || activeBaseRoute === PromotionRoutes.baseRoute,
      icon: "sales_bold"
    });
  }
  let tmp$3;
  tmp$3 = scope.TAG === "Organisation" ? I18n.t("Shops") : I18n.t("Shop");
  return JsxRuntime.jsxs(Nav.make, {
    children: [JsxRuntime.jsxs(Nav.NavSection.make, {
      children: [JsxRuntime.jsx(Nav.NavLink.make, {
        to: {
          TAG: "Route",
          _0: AnalyticsRoutes.overviewRoute
        },
        label: I18n.t("General performances"),
        active: activeRoute === AnalyticsRoutes.overviewRoute,
        restrictedMode: restrictedModeForAnalytics
      }), tmp, JsxRuntime.jsx(Nav.NavLink.make, {
        to: {
          TAG: "Route",
          _0: AnalyticsRoutes.topPerformingProductsRoute
        },
        label: I18n.t("Top sold products"),
        active: activeRoute === AnalyticsRoutes.topPerformingProductsRoute,
        restrictedMode: restrictedModeForAnalytics
      }), JsxRuntime.jsx(Nav.NavLink.make, {
        to: {
          TAG: "Route",
          _0: AnalyticsRoutes.topPerformingStaffsRoute
        },
        label: I18n.t("Top staffs"),
        active: activeRoute === AnalyticsRoutes.topPerformingStaffsRoute,
        betaBadge: true,
        restrictedMode: restrictedModeForAnalytics
      }), JsxRuntime.jsx(Nav.NavLink.make, {
        to: {
          TAG: "Route",
          _0: AnalyticsRoutes.cashFlowRoute
        },
        label: I18n.t("Cash flow"),
        active: activeRoute === AnalyticsRoutes.cashFlowRoute,
        restrictedMode: restrictedModeForAnalytics
      })],
      title: I18n.t("Activity reports"),
      active: activeBaseRoute === AnalyticsRoutes.baseRoute,
      icon: "analytics_bold"
    }), JsxRuntime.jsxs(Nav.NavSection.make, {
      children: [JsxRuntime.jsx(Nav.NavLink.make, {
        to: {
          TAG: "Route",
          _0: CatalogRoutes.baseRoute
        },
        label: I18n.t("Catalog"),
        active: activeBaseRoute === CatalogRoutes.baseRoute,
        restrictedMode: !Auth.isAuthorizedAccess(role, OrderRoutes.baseRoute)
      }), JsxRuntime.jsx(Nav.NavLink.make, {
        to: {
          TAG: "Route",
          _0: OrderRoutes.baseRoute
        },
        label: I18n.t("Orders"),
        active: activeBaseRoute === OrderRoutes.baseRoute,
        restrictedMode: !Auth.isAuthorizedAccess(role, OrderRoutes.baseRoute)
      }), JsxRuntime.jsx(Nav.NavLink.make, {
        to: {
          TAG: "Route",
          _0: StockActivityRoutes.baseRoute
        },
        label: I18n.t("Stock activities"),
        active: activeBaseRoute === StockActivityRoutes.baseRoute,
        restrictedMode: !Auth.isAuthorizedAccess(role, StockActivityRoutes.baseRoute)
      }), tmp$1],
      title: I18n.t("Products"),
      active: activeBaseRoute === CatalogRoutes.baseRoute || activeBaseRoute === OrderRoutes.baseRoute || activeBaseRoute === StockActivityRoutes.baseRoute || activeBaseRoute === StockTransferRoutes.baseRoute,
      icon: "products_bold"
    }), tmp$2, JsxRuntime.jsxs(Nav.NavSection.make, {
      children: [JsxRuntime.jsx(Nav.NavLink.make, {
        to: {
          TAG: "Route",
          _0: SupplierRoutes.baseRoute
        },
        label: I18n.t("Suppliers"),
        active: activeBaseRoute === SupplierRoutes.baseRoute,
        restrictedMode: !Auth.isAuthorizedAccess(role, SupplierRoutes.baseRoute)
      }), JsxRuntime.jsx(Nav.NavLink.make, {
        to: {
          TAG: "Route",
          _0: CustomerRoutes.baseRoute
        },
        label: I18n.t("Customers"),
        active: activeBaseRoute === CustomerRoutes.baseRoute,
        betaBadge: true,
        restrictedMode: !Auth.isAuthorizedAccess(role, CustomerRoutes.baseRoute)
      })],
      title: I18n.t("Contacts"),
      active: activeBaseRoute === SupplierRoutes.baseRoute || activeBaseRoute === CustomerRoutes.baseRoute,
      icon: "contacts_bold"
    }), JsxRuntime.jsxs(Nav.NavSection.make, {
      children: [JsxRuntime.jsx(Nav.NavLink.make, {
        to: {
          TAG: "Route",
          _0: SettingsRoutes.shopsRoute
        },
        label: tmp$3,
        active: activeRoute === SettingsRoutes.shopsRoute,
        restrictedMode: !Auth.isAuthorizedAccess(role, SettingsRoutes.baseRoute)
      }), JsxRuntime.jsx(Nav.NavLink.make, {
        to: {
          TAG: "Route",
          _0: SettingsRoutes.labelPrinterRoute
        },
        label: I18n.t("Label printer"),
        active: activeRoute === SettingsRoutes.labelPrinterRoute,
        restrictedMode: !Auth.isAuthorizedAccess(role, SettingsRoutes.baseRoute)
      }), JsxRuntime.jsx(Nav.NavLink.make, {
        to: {
          TAG: "Route",
          _0: SettingsRoutes.billingAccountShowRoute(undefined, undefined)
        },
        label: I18n.t("Subscription and billing"),
        active: activeRoute === SettingsRoutes.billingAccountShowRoute(undefined, undefined),
        restrictedMode: !settingsAccessAuthorized
      }), JsxRuntime.jsx(Nav.NavLink.make, {
        to: {
          TAG: "Route",
          _0: SettingsRoutes.electronicInvoicingRoute
        },
        label: I18n.t("settings_electronic_invoicing_page.title"),
        active: activeRoute === SettingsRoutes.electronicInvoicingRoute,
        betaBadge: true,
        restrictedMode: !settingsAccessAuthorized
      })],
      title: I18n.t("Settings"),
      active: activeBaseRoute === SettingsRoutes.baseRoute,
      icon: "settings_bold"
    }), userCanUseImpersonation ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [JsxRuntime.jsx(CanarySeparator.make, {
        orientation: "horizontal",
        spacing: "s"
      }), JsxRuntime.jsxs(Nav.NavSection.make, {
        children: [JsxRuntime.jsx(Nav.NavLink.make, {
          to: {
            TAG: "Route",
            _0: AdminRoutes.impersonationRoute
          },
          label: I18n.t("Impersonation"),
          active: activeRoute === AdminRoutes.impersonationRoute
        }), JsxRuntime.jsx(Nav.NavLink.make, {
          to: {
            TAG: "Route",
            _0: AdminRoutes.shopsRoute
          },
          label: I18n.t("Shops"),
          active: activeRoute === AdminRoutes.shopsRoute
        })],
        title: I18n.t("Customer support"),
        active: activeBaseRoute === AdminRoutes.baseRoute,
        icon: "customer_support"
      })]
    }) : null],
    userOrganizationName: props.userOrganizationName,
    userName: props.userName,
    userProfilePictureUri: props.userProfilePictureUri,
    badge: badge,
    userImpersonating: userImpersonating,
    userSettingsRoute: SettingsRoutes.userRoute,
    helpCenterUrl: new URL("https://help.wino.fr"),
    onToggleHelpCenter: HelpCenter.showMessages,
    onRequestLogout: onRequestLogout
  });
}
let NavBar = {
  make: App$NavBar
};
function appIndexRoute(userRole) {
  if (Auth.isAuthorizedAccess(userRole, AnalyticsRoutes.overviewRoute)) {
    return AnalyticsRoutes.overviewRoute;
  } else {
    return CatalogRoutes.baseRoute;
  }
}
function App(props) {
  let navigate = Navigation.useNavigate();
  let url = Navigation.useUrl();
  let urlPath = Stdlib_List.fromArray(url.path);
  let route = Navigation.urlToRoute(url);
  let userRole = Auth.useRole();
  let auth = Auth.useState();
  let captureEvent = SessionTracker.useCaptureEvent();
  let match = LegacyDashboard.useBanner();
  let match$1 = React.useState(() => route);
  let setRouteAfterSessionExpiration = match$1[1];
  let routeAfterSessionExpiration = match$1[0];
  let appIndexRoute$1 = appIndexRoute(userRole);
  React.useEffect(() => {
    HelpCenter.setup(Env.intercomAppID());
  }, []);
  React.useEffect(() => {
    if (typeof auth !== "object" || auth.TAG === "Logging") {
      HelpCenter.updateUserFields(I18n.t("Guest"), undefined, undefined, undefined);
    } else {
      let match = auth._0;
      let match$1 = match.user;
      let email = match$1.username;
      let userId = match$1.id;
      if (match$1.impersonating) {
        HelpCenter.updateUserFields(I18n.t("Imposter"), undefined, undefined, undefined);
      } else {
        let match$2 = match.activeShop;
        let exit = 0;
        if (match$2 !== undefined) {
          let name = match$2.legalRepresentative;
          if (name !== undefined) {
            HelpCenter.updateUserFields(name, userId, email, undefined);
          } else {
            exit = 1;
          }
        } else {
          exit = 1;
        }
        if (exit === 1) {
          HelpCenter.updateUserFields(match$1.name, userId, email, undefined);
        }
      }
    }
    if (typeof auth === "object" && auth.TAG !== "Logging") {
      let match$3 = auth._0;
      let match$4 = match$3.activeShop;
      let match$5 = match$3.user;
      let userName = match$5.name;
      let userId$1 = match$5.id;
      if (match$4 !== undefined) {
        BugTracker.updateUserFields(userId$1, userName, match$4.id, match$4.name, match$4.activeWebDeviceId, undefined);
      } else {
        BugTracker.updateUserFields(userId$1, userName, undefined, undefined, undefined, undefined);
      }
    }
    if (typeof auth === "object" && auth.TAG !== "Logging") {
      let match$6 = auth._0.user;
      if (!match$6.impersonating) {
        SessionTracker.updateUserFields(match$6.id, match$6.name, match$6.username);
        let sessionUrl = SessionTracker.getSessionUrl();
        BugTracker.updateSessionUrl(sessionUrl);
        HelpCenter.updateSessionUrl(sessionUrl);
      }
    }
  }, [auth]);
  React.useEffect(() => {
    if (typeof auth !== "object") {
      if (route === AuthRoutes.logoutRoute || !route.startsWith(AuthRoutes.baseRoute) && !route.startsWith(ComplianceRoutes.baseRoute)) {
        navigate(undefined, AuthRoutes.loginRoute);
      } else if (route === AuthRoutes.logoutSessionExpiredRoute) {
        navigate(undefined, AuthRoutes.loginSessionExpiredRoute);
      } else if (route === AuthRoutes.logoutImpersonationFailureRoute) {
        navigate(undefined, AuthRoutes.loginImpersonationFailureRoute);
      }
    } else if (auth.TAG !== "Logging") {
      if (route === "/" || route.startsWith(AuthRoutes.loginRoute)) {
        if (!routeAfterSessionExpiration.startsWith(AuthRoutes.baseRoute) && route === AuthRoutes.loginSessionExpiredRoute) {
          navigate(undefined, routeAfterSessionExpiration);
        } else {
          navigate(undefined, appIndexRoute$1);
        }
      }
    }
  }, [route, auth]);
  React.useEffect(() => {
    if (!route.startsWith(AuthRoutes.baseRoute)) {
      setRouteAfterSessionExpiration(param => route);
    }
  }, [route]);
  if (urlPath === 0) {
    return JsxRuntime.jsx(LoadingPage.make, {});
  }
  let subUrlPath = urlPath.tl;
  let basePathname = urlPath.hd;
  if (basePathname === ComplianceRoutes.basePathname) {
    return JsxRuntime.jsx(ComplianceRouter.make, {
      subUrlPath: subUrlPath
    });
  }
  if (basePathname === AuthRoutes.basePathname) {
    return JsxRuntime.jsx(AuthRouter.make, {
      subUrlPath: subUrlPath,
      appIndexRoute: appIndexRoute$1
    });
  }
  if (typeof auth !== "object") {
    return JsxRuntime.jsx(LoadingPage.make, {});
  }
  if (auth.TAG === "Logging") {
    return JsxRuntime.jsx(LoadingPage.make, {});
  }
  let match$2 = auth._0;
  let activeShop = match$2.activeShop;
  let user = match$2.user;
  let baseRoute = "/" + basePathname;
  let navBar = JsxRuntime.jsx(App$NavBar, {
    userOrganizationName: user.organizationName,
    userProfilePictureUri: user.profilePictureUri,
    userName: user.name,
    userCanUseImpersonation: user.canUseImpersonation,
    userImpersonating: user.impersonating,
    activeBaseRoute: baseRoute,
    activeRoute: route
  });
  let alertBar;
  if (activeShop !== undefined && url.pathname !== SettingsRoutes.shopsRoute && SettingsShopsPage.requiredDataMissing(activeShop) && Auth.isAuthorizedAccess(userRole, SettingsRoutes.shopsRoute)) {
    let i18nPrefix = "app.shop_required_data_alert.";
    alertBar = JsxRuntime.jsx(make, {
      variation: "warning",
      title: I18n.t(i18nPrefix + "title"),
      subtitle: I18n.template(I18n.t(i18nPrefix + "subtitle"), {
        shopName: activeShop.name
      }, undefined),
      link: {
        TAG: "RouteWithQueryString",
        _0: SettingsRoutes.shopsRoute,
        _1: SettingsRoutes.shopsRequiredDataQuery
      },
      textLink: I18n.t(i18nPrefix + "link"),
      onPress: param => captureEvent("alert_bar_click_shop_required_data")
    });
  } else {
    alertBar = null;
  }
  let alertBar$1 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [alertBar, match[0] ? JsxRuntime.jsx(make, {
      variation: "info",
      title: I18n.t("legacy_dashboard_notice_banner.title"),
      subtitle: I18n.t("legacy_dashboard_notice_banner.text"),
      onRequestClose: match[1]
    }) : null]
  });
  return JsxRuntime.jsx(AppLayout.make, {
    children: baseRoute === AnalyticsRoutes.baseRoute ? JsxRuntime.jsx(AnalyticsRouter.make, {
      subUrlPath: subUrlPath
    }) : baseRoute === StockActivityRoutes.baseRoute ? JsxRuntime.jsx(StockActivityRouter.make, {
      subUrlPath: subUrlPath
    }) : baseRoute === LoadingRoutes.baseRoute(undefined, undefined) ? JsxRuntime.jsx(LoadingRouter.make, {
      subUrlPath: subUrlPath
    }) : baseRoute === StockTransferRoutes.baseRoute ? JsxRuntime.jsx(StockTransferRouter.make, {
      subUrlPath: subUrlPath
    }) : baseRoute === SettingsRoutes.baseRoute ? JsxRuntime.jsx(SettingsRouter.make, {
      subUrlPath: subUrlPath,
      appIndexRoute: appIndexRoute$1
    }) : baseRoute === AdminRoutes.baseRoute ? JsxRuntime.jsx(AdminRouter.make, {
      subUrlPath: subUrlPath,
      appIndexRoute: appIndexRoute$1
    }) : baseRoute === SupplierRoutes.baseRoute ? JsxRuntime.jsx(SupplierRouter.make, {
      subUrlPath: subUrlPath
    }) : baseRoute === AccountingRoutes.baseRoute ? JsxRuntime.jsx(AccountingRouter.make, {
      subUrlPath: subUrlPath
    }) : baseRoute === CustomerRoutes.baseRoute ? JsxRuntime.jsx(CustomerRouter.make, {
      subUrlPath: subUrlPath
    }) : baseRoute === SalesRoutes.baseRoute ? JsxRuntime.jsx(SalesRouter.make, {
      subUrlPath: subUrlPath
    }) : baseRoute === CashRegisterReportsRoutes.baseRoute ? JsxRuntime.jsx(CashRegisterReportsRouter.make, {
      subUrlPath: subUrlPath
    }) : baseRoute === DesignSystemRoutes.baseRoute ? JsxRuntime.jsx(DesignSystemPage.Router.make, {
      subUrlPath: subUrlPath
    }) : baseRoute === OrderRoutes.baseRoute ? JsxRuntime.jsx(OrderRouter.make, {}) : baseRoute === PromotionRoutes.baseRoute ? JsxRuntime.jsx(PromotionRouter.make, {}) : baseRoute === CatalogRoutes.baseRoute ? JsxRuntime.jsx(CatalogRouter.make, {}) : JsxRuntime.jsx(NotFoundPage.make, {}),
    navBar: navBar,
    alertBar: alertBar$1
  });
}
let maintenance = false;
let make$1 = App;
export { maintenance, AlertBar, NavBar, appIndexRoute, make$1 as make };
/* styles Not a pure module */